/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { IDescriptionTechTableNew, ITableDataModal } from "pages/StepPages/StepFour/One/Tables/models";
import { useParams } from "react-router-dom";
import ModalPortal from "components-new/ModalPortal";
import sass from "pages/StepPages/StepFour/One/Tables/TableNavigate/LevelsOfVariantsTable/levels.module.sass";
import InputTemp from "components-new/InputTemp";
import TextArea from "components-new/Textarea";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import GroupCheck from "components-new/GroupCheck";
import { CreateContext } from "pages/StepPages/StepFour/One/Tables/Tables";
import { ReactComponent as SearchIcon } from "images/SearchIcon.svg";
import { ChangeActiveTabContext, ITab } from "pages/StepPages/StepFour/One/Tables/TableNavigate/TableNavigate";
import List from "pages/StepPages/StepFour/One/Tables/TableNavigate/ListCurrentThreatsTable/ListTactics";
import { snackWrapper } from "helpers";
import { fromTable } from "pages/StepPages/StepFour/One/Tables/TableNavigate/DescriptionTable/Modals";
import { usePaginationWithIntersection } from "hooks/usePaginationWithIntersection";
import { ActualThreatResponse } from "libs/apiClient/data-contracts";
import { directoryAPI } from "libs/apiClient/Directory";
import { organizationAPI } from "libs/apiClient/Organization";

const initial: Omit<ActualThreatResponse, "systemMeans" | "tacticTechnic"> & {
	systemMeans: { id: number; name: string }[] | null;
	tacticTechnic: { id: number; name: string }[] | null;
} = {
	id: 0,
	availability: false,
	integrity: false,
	description: "",
	privacy: false,
	ubi: "",
	influence: "",
	sourceText: "",
	ubiName: "",
	tacticTechnic: [],
	systemMeans: [],
};
const PossibkeObjectsModal: React.FC<ITableDataModal<ActualThreatResponse>> = ({
	toggle,
	replace,
	active,
	data = [],
	close,
}) => {
	const { description } = useContext(CreateContext);

	const { changeTab, updateTabs } = useContext(ChangeActiveTabContext);

	const [optionsTactics, setOptionsTactics] = useState<{ id: number; name: string }[]>([]);

	const [currentObject, setCurrentObject] = useState<
		Omit<ActualThreatResponse, "systemMeans" | "tacticTechnic"> & {
			systemMeans: { id: number; name: string }[] | null;
			tacticTechnic: { id: number; name: string }[] | null;
		}
	>(initial);

	const [options, setOptions] = useState<{ id: number; name: string }[]>([]);

	const [optionsTech, setTechOptions] = useState<{ id: number; name: string }[]>([]);

	useEffect(() => {
		directoryAPI.dropdownThreatSourcesList().then(({ data }) => {
			setOptions(data.map((_, index) => ({ id: index + 1, name: _ })));
		});
		organizationAPI.objectTacticShortDetail(+params.threadId!).then(({ data }) => {
			setOptionsTactics(data.map((_, index) => ({ id: index + 1, name: _ })));
		});
		//eslint-disable-next-line
	}, [toggle]);

	const params = useParams();

	const changeField = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setCurrentObject((prevState: any) => {
			return { ...prevState, [name]: value };
		});
	};

	const title = useMemo(() => {
		return `${toggle === "edit" ? "Редактирование: " : "Создание: "}Перечень актуальных угроз безопасности информации`;
	}, [toggle]);

	useEffect(() => {
		if (active) {
			console.log(active);
			setCurrentObject({
				...active,
				privacy: !!active?.privacy,
				availability: !!active?.availability,
				integrity: !!active?.integrity,
				tacticTechnic: active.tacticTechnic
					? ([...active.tacticTechnic].map((_, index) => ({
							id: index + 1,
							name: _,
					  })) as typeof initial.tacticTechnic)
					: [],
				systemMeans: active.systemMeans ? active.systemMeans.map((_, index) => ({ id: index + 1, name: _ })) : null,
			});
		} else {
			setCurrentObject(initial);
		}
	}, [active, toggle]);

	const changeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, checked } = e.target;
		setCurrentObject((prevState) => ({ ...prevState, [name]: checked }));
	};
	const save = () => {
		const { id, ...rest } = currentObject;
		const upload = {
			...rest,
			systemMeans: rest.systemMeans?.length ? rest.systemMeans.map((_) => _.name) : null,
			tacticTechnic: rest.tacticTechnic?.length ? rest.tacticTechnic.map((_) => _.name) : null,
		};
		if (toggle === "edit") {
			organizationAPI.objectThreatsActualUpdate(id, upload).then((r) => {
				const response = r.data;
				const newData = [...data].map((_) => (_.id === response.id ? response : _));
				setCurrentObject(initial);
				replace(newData);
				snackWrapper("success", "Таблица обновлена");
				updateTabs("ACTUAL");
				close();
			});
		} else if (toggle === "create") {
			organizationAPI.objectThreatsActualCreate(+params.threadId!, upload).then((r) => {
				const newData = [...data, r.data];
				setCurrentObject(initial);
				replace(newData);
				snackWrapper("success", "Таблица обновлена");
				updateTabs("ACTUAL");
				close();
			});
		}
	};

	const disabled = useMemo(() => {
		const check = [currentObject.privacy, currentObject.availability, currentObject.integrity].every((_) => {
			return !_;
		});
		return (
			!currentObject.ubi ||
			!currentObject.ubiName ||
			!currentObject.description ||
			!currentObject.sourceText ||
			!currentObject.influence ||
			!currentObject.tacticTechnic?.length ||
			!currentObject.systemMeans?.length ||
			check
		);
	}, [currentObject]);

	const refDrop = useRef<HTMLDivElement>(null);
	const [target, setTarget] = useState<HTMLParagraphElement | null>(null);

	useEffect(() => {
		function handleClickOutside(event: any) {
			if (refDrop.current && target && !refDrop.current.contains(event.target)) {
				setTimeout(() => {
					setTarget(null);
				}, 0);
			}
		}

		document.addEventListener("mouseup", handleClickOutside);
		return () => {
			document.removeEventListener("mouseup", handleClickOutside);
		};
	}, [refDrop, target]);

	const [searchTactic, setSearchTactic] = useState("");
	const [searchTech, setSearchTech] = useState("");

	const filteredOptionsTactics = useMemo(() => {
		return optionsTactics.filter((_) => _.name.toLowerCase().includes(searchTactic.toLowerCase()));
	}, [searchTactic, optionsTactics]);

	const filteredOptionsTech = useMemo(() => {
		return optionsTech.filter((_) => _.name.toLowerCase().includes(searchTech.toLowerCase()));
	}, [searchTech, optionsTech]);
	const changeTactics = (item: { name: string; id: number }, field: string) => {
		const key = field === "systemMeans" ? "systemMeans" : "tacticTechnic";
		if (currentObject[key] && currentObject[key]!.find((_) => item.name === _.name)) {
			setCurrentObject((prevState) => ({
				...prevState,
				[key]: prevState[key]!.filter((select) => select.name !== item.name),
			}));
		} else {
			setCurrentObject((prevState) => {
				return {
					...prevState,
					[key]: prevState[key] && prevState[key]!.length ? [...prevState[key]!, item] : [item],
				};
			});
		}
	};

	const [paramsMeans, setParamsMeans] = useState({
		part: 1,
		count: 30,
	});

	const thenHandler = (data: IDescriptionTechTableNew[]) => {
		const upPart = (prevState: typeof paramsMeans) => ({ ...prevState, part: prevState.part + 1 });
		if (paramsMeans.part === 1) {
			if (data.length === paramsMeans.count) {
				setParamsMeans(upPart);
			}
			if (!data.length || data.length < paramsMeans.count) {
				setIsFinally(true);
			}
			setTechOptions(
				Array.from(
					new Set([...data.map((_) => `${_.type} ${_.name} (${fromTable[_.from as keyof typeof fromTable]})`)]),
				).map((_, index) => ({ id: index + 1, name: _ })),
			);
		} else {
			setTechOptions((prevState) => {
				return Array.from(
					new Set([
						...prevState.map((_) => _.name),
						...data.map((_) => `${_.type} ${_.name} (${fromTable[_.from as keyof typeof fromTable]})`),
					]),
				).map((_, index) => ({ id: index + 1, name: _ }));
			});
			if (data.length < paramsMeans.count) {
				setIsFinally(true);
			} else {
				setParamsMeans(upPart);
			}
		}
	};

	const wrapperMeans = useRef<HTMLDivElement | null>(null);
	const lastMeans = useRef<HTMLLabelElement | null>(null);

	const { setIsFinally } = usePaginationWithIntersection({
		link: `/organization/object/system/${description?.id}/means`,
		then: thenHandler,
		ref: wrapperMeans,
		params: paramsMeans,
		dependencies: [description?.id],
		lastTarget: lastMeans,
	});

	return toggle !== null ? (
		<ModalPortal factor={"window"} outSide={false} size={"lg"} title={title} handleClose={close}>
			<div className={sass.modal}>
				<InputTemp
					onChange={changeField}
					name={"ubi"}
					value={currentObject.ubi}
					label={"УБИ"}
					placeholder={"Введите текст"}
					required={true}
				/>
				<InputTemp
					onChange={changeField}
					name={"ubiName"}
					value={currentObject.ubiName}
					label={"Наименование уби"}
					placeholder={"Введите текст"}
					required={true}
				/>
				<TextArea
					onChange={changeField}
					name={"description"}
					value={currentObject.description || ""}
					placeholder={"Введите текст"}
					label={"Описание"}
					required={true}
					rows={10}
				/>
				<InputTemp
					onChange={changeField}
					name={"sourceText"}
					options={options}
					filter
					emptyOptions={false}
					field={"name"}
					onSelect={(e) => {
						setCurrentObject((prevState) => ({ ...prevState, sourceText: e.name }));
					}}
					value={currentObject.sourceText || ""}
					label={"Источник угрозы"}
					placeholder={"Введите текст"}
					required={true}
				/>
				<InputTemp
					onChange={changeField}
					name={"influence"}
					value={currentObject.influence || ""}
					label={"Объект воздействия"}
					placeholder={"Введите текст"}
					required={true}
				/>
				<div className={sass.selectBox}>
					<span className={sass.selectBox_label}>
						Тактики и техники реализации угроз <span className={sass.required}>*</span>
					</span>

					<div className={sass.selectBox_list}>
						<div className={sass.selectBox_search}>
							<SearchIcon />
							<input
								value={searchTactic}
								placeholder={"Поиск тактик"}
								onChange={(e) => {
									setSearchTactic(e.target.value);
								}}
								type="text"
							/>
						</div>
						<div className={sass.selectBox_list_wrapper}>
							{searchTactic ? (
								filteredOptionsTactics.length ? (
									<List
										data={filteredOptionsTactics}
										check={changeTactics}
										current={currentObject}
										field={"tacticTechnic"}
									/>
								) : (
									<label className={sass.selectBox_list_wrapper_item}>Ничего не найдено</label>
								)
							) : optionsTactics.length ? (
								<List data={optionsTactics} check={changeTactics} current={currentObject} field={"tacticTechnic"} />
							) : (
								<div
									onClick={() => {
										changeTab(
											{
												id: 9,
												tab: "list_of_basic",
												name: "Перечень основных тактик и соответствующих им типовых техник",
											} as ITab,
											false,
										);
									}}
									className={sass.selectBox_list_empty}>
									<span className={sass.link}>Тактик пока нет, сформировать тактики</span>
								</div>
							)}
						</div>
					</div>
				</div>

				<div className={sass.selectBox}>
					<span className={sass.selectBox_label}>
						Технические средства <span className={sass.required}>*</span>
					</span>

					<div className={sass.selectBox_list}>
						<div className={sass.selectBox_search}>
							<SearchIcon />
							<input
								value={searchTech}
								placeholder={"Поиск тех. средств"}
								onChange={(e) => {
									setSearchTech(e.target.value);
								}}
								type="text"
							/>
						</div>
						<div ref={wrapperMeans} className={sass.selectBox_list_wrapper}>
							{searchTech ? (
								filteredOptionsTech.length ? (
									<List
										lastElement={lastMeans}
										data={filteredOptionsTech}
										check={changeTactics}
										current={currentObject}
										field={"systemMeans"}
									/>
								) : (
									<label className={sass.selectBox_list_wrapper_item}>Ничего не найдено</label>
								)
							) : optionsTech.length ? (
								<List
									lastElement={lastMeans}
									data={optionsTech}
									field={"systemMeans"}
									check={changeTactics}
									current={currentObject}
								/>
							) : (
								<div
									onClick={() => {
										changeTab(
											{
												id: 1,
												tab: "description",
												name: "Описание системы и ее характеристика как объекта защиты",
											} as ITab,
											false,
										);
									}}
									className={sass.selectBox_list_empty}>
									<span className={sass.link}>Технических средств пока нет, добавьте технические средства</span>
								</div>
							)}
						</div>
					</div>
				</div>

				<GroupCheck.Wrapper label={"Категория нарушителей"} required={true}>
					<GroupCheck.Item
						onChange={changeCheckbox}
						name={"privacy"}
						checked={currentObject.privacy !== null && currentObject.privacy}
						label={"К"}
						type={"checkbox"}
					/>
					<GroupCheck.Item
						onChange={changeCheckbox}
						name={"integrity"}
						checked={currentObject.integrity !== null && currentObject.integrity}
						label={"Ц"}
						type={"checkbox"}
					/>
					<GroupCheck.Item
						onChange={changeCheckbox}
						name={"availability"}
						checked={currentObject.availability !== null && currentObject.availability}
						label={"Д"}
						type={"checkbox"}
					/>
				</GroupCheck.Wrapper>
				<div className={sass.btn}>
					<Button onClick={close} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button disabled={disabled} onClick={save} variant={BUTTON_VARIANTS.CONTAINED}>
						Сохранить
					</Button>
				</div>
			</div>
		</ModalPortal>
	) : null;
};

export default PossibkeObjectsModal;
